<mat-dialog-content>
  <lemon-dialog-header>
    @if (!uusiSalasana()) {
      <span>Vaihda käyttäjän salasana</span>
    }
    @if (uusiSalasana()) {
      <span>Salasana vaihdettiin onnistuneesti</span>
    }
  </lemon-dialog-header>

  <div style="padding-left: 3em; padding-right: 3em">
    @if (!uusiSalasana() && !commonError()) {
      <p>Haluatko varmasti vaihtaa käyttäjän salasanan?</p>
    }

    @if (uusiSalasana()) {
      <div>
        <p>HUOM! Salasanaa ei tallenneta! Tämän dialogin sulkeminen hävittää sen lopullisesti!</p>
        <p>Salasana: {{ uusiSalasana() }}</p>
      </div>
    }

    @if (commonError()) {
      <div class="error-text">
        {{ commonError() }}
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  @if (!uusiSalasana() && !commonError()) {
    <app-primary-button (click)="vaihdaSalasana()" actionId="Vaihda salasana">Vaihda salasana</app-primary-button>
  }
  @if (uusiSalasana() || commonError()) {
    <app-primary-button mat-dialog-close actionId="Luotu uusi salasana: Virhe (Sulje dialog)">OK</app-primary-button>
  }
</mat-dialog-actions>
